import { get } from '../index';

export const search = (value) => {
  return get(`tag?name=${value}`);
};